// SPDX-FileCopyrightText: Copyright 2025 New Vector Ltd.
// SPDX-FileCopyrightText: Copyright 2025, 2026 Element Creations Ltd.
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial

import styles from "./loading.module.css";

export const Loading = () => (
  <svg
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles["loading"]}
  >
    <defs>
      <linearGradient id="sdk_grad_splash" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0EA5E9" />
        <stop offset="100%" stopColor="#2563EB" />
      </linearGradient>
      <linearGradient
        id="inner_grad_splash"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#F1F5F9" />
      </linearGradient>
      <filter id="glow_splash" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow
          dx="0"
          dy="6"
          stdDeviation="8"
          floodColor="#1E40AF"
          floodOpacity="0.3"
        />
      </filter>
    </defs>
    <g className={styles["pulse"]}>
      <rect
        width="200"
        height="200"
        rx="52"
        fill="url(#sdk_grad_splash)"
        filter="url(#glow_splash)"
      />
      <path
        d="M52 74C52 57.4315 65.4315 44 82 44H118C134.569 44 148 57.4315 148 74V96C148 112.569 134.569 126 118 126H86L62 144V123.8C55.88 119.5 52 112.4 52 104V74Z"
        fill="url(#inner_grad_splash)"
      />
      <rect x="76" y="68" width="34" height="28" rx="6" fill="#2563EB" />
      <path d="M110 75L124 67V97L110 89V75Z" fill="#0EA5E9" />
      <circle cx="93" cy="82" r="5" fill="#38BDF8" />
      <circle cx="93" cy="82" r="2.2" fill="#FFFFFF" />
    </g>
  </svg>
);
